import { render, staticRenderFns } from "./UpdateTransferStock.vue?vue&type=template&id=5cdb8dca&"
import script from "./UpdateTransferStock.vue?vue&type=script&lang=js&"
export * from "./UpdateTransferStock.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTransferStock.vue?vue&type=style&index=0&id=5cdb8dca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports